module.exports = function () {
    $('body').on('click', '.js-qty-minus, .js-qty-plus', function () {
        const $btn = $(this);
        const isMinus = $btn.hasClass('js-qty-minus');
        const $wrapper = $btn.closest('.js-cart-qty');
        const $input = $wrapper.find('.js-qty-input');
    
        // Parse current, min, and max values
        const currentVal = parseInt($input.val(), 10) || 0;
        const minVal = parseInt($btn.data('minQuantity'), 10) || 1;
        const maxVal = parseInt($btn.data('maxQuantity'), 10) || 99999;
    
        // Determine the increment/decrement
        let newVal = isMinus ? currentVal - 1 : currentVal + 1;
    
        if (newVal < minVal) newVal = minVal;
        if (newVal > maxVal) newVal = maxVal;
    
        $input.val(newVal).trigger('input');
      });
};